import { useQuery } from '@tanstack/react-query';
import { machineAPI } from '../../services/api';
import { MachineOccupation } from '../../types/machine';

/**
 * Which machines are busy now / next. Derived from time slots, so it changes as
 * the clock moves even when nobody saves anything: refreshed every minute.
 */
export function useMachineOccupation() {
  return useQuery<MachineOccupation>({
    queryKey: ['machines', 'occupation'],
    queryFn: () => machineAPI.getOccupation(),
    staleTime: 30_000,
    refetchInterval: 60_000,
  });
}
